import { render, staticRenderFns } from "./health-tracker.vue?vue&type=template&id=3e082ac2&"
import script from "./health-tracker.vue?vue&type=script&lang=js&"
export * from "./health-tracker.vue?vue&type=script&lang=js&"
import style0 from "./health-tracker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports